import React from 'react';
import {Grid, ListItem, Button, Typography} from '@material-ui/core';
import {MyAccordion, MyAccordionSummary, MyAccordionDetails} from '../Accordions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {NavLink} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {H6} from 'components/TypographyShortcuts';
import InfoModal from 'components/widgets/tooltips/InfoModal';
import sectionContent from 'components/widgets/checklists/ChecklistSectionContent';
import MMCdomestic from 'components/mmld/MMCtools/MMCdomestic';

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            width: '20em',
            height: '15em',
        },
        [theme.breakpoints.up('md')]: {
            width: '40em',
            height: '30em',
        },
    },
    accordion: {
        justifyContent: 'stretch',
        background:
            theme.palette.type === 'dark'
                ? theme.palette.success.dark
                : theme.palette.success.light,
    },
    summary: {
        background:
            theme.palette.type === 'dark'
                ? theme.palette.success.dark
                : theme.palette.success.light,
    },
    details: {
        justify: 'stretch',
        background:
            theme.palette.type === 'dark'
                ? theme.palette.success.dark
                : theme.palette.success.light,
    },
}));

const ChecklistSectionTrainingDomestic = ({sectionId, checkoffs, mmld}) => {
    const classes = useStyles();
    const {labelId, title, link, link_text, infoModalContent} =
        sectionContent?.[sectionId];

    return (
        <MyAccordion className={classes.accordion}>
            <MyAccordionSummary
                className={classes.summary}
                expandIcon={<ExpandMoreIcon />}
            >
                <Grid container className={classes.titleContainer}>
                    <Grid
                        item
                        style={{
                            display: 'flex',
                            justifyContent: 'left',
                        }}
                        xs={12}
                    >
                        {title ? (
                            <H6>
                                <strong>{title}</strong>
                            </H6>
                        ) : null}
                        <InfoModal content={infoModalContent} />
                    </Grid>
                </Grid>
            </MyAccordionSummary>
            <MyAccordionDetails className={classes.details}>
                <Grid container>
                    <Grid item style={{padding: '1rem'}}>
                        <MMCdomestic mmld={mmld} doc_type='MMC' noheader='true' />
                    </Grid>

                    <ListItem key={labelId} role='button' dense button>
                        <Grid container direction='column'>
                            <Grid>
                                {checkoffs.application_checklist.ss_days_5_years >=
                                360 ? (
                                    <Grid item>
                                        <Typography variant='body2'>
                                            <strong>Congratulations!!!</strong>
                                            <strong>
                                                You have over 360 days in the last
                                                five years.
                                            </strong>
                                        </Typography>
                                        <p></p>
                                        <Typography variant='body2'>
                                            You are able to renew your Domestic
                                            Officer and/or Ratings using just sea
                                            service.
                                        </Typography>
                                    </Grid>
                                ) : (
                                    <Grid item>
                                        <Typography variant='body2'>
                                            <strong>
                                                You have less than 360 days in the
                                                last five years.
                                            </strong>
                                        </Typography>
                                        <p></p>
                                        <Typography variant='body2'>
                                            <strong>Don't stress out!</strong>
                                        </Typography>
                                        <Typography variant='body2'>
                                            You are able to renew your Domestic
                                            Officer and/or Ratings right now by
                                            taking OPEN BOOK take home tests. After
                                            your application has been submitted, the
                                            NMC will email you OPEN BOOK tests for
                                            every domestic endorsement that you hold.
                                        </Typography>
                                        <p></p>
                                        <Typography variant='body2'>
                                            If you don’t want to take an OPEN BOOK
                                            take home test, that we are sure you will
                                            do great on, you can typically find
                                            renewal courses for every domestic
                                            endorsement that you hold under 200GRT.
                                        </Typography>
                                        <p></p>
                                        <Typography variant='body2'>
                                            We believe it is a waste of your money
                                            but you can do it! (OPEN BOOK DUDE!)
                                        </Typography>
                                        <Grid item style={{paddingTop: '0.5rem'}}>
                                            <Button
                                                component={NavLink}
                                                to={link}
                                                variant='contained'
                                                color='secondary'
                                                style={{
                                                    width: 'fit-content',
                                                }}
                                            >
                                                {link_text}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </ListItem>
                </Grid>
            </MyAccordionDetails>
        </MyAccordion>
    );
};
export default ChecklistSectionTrainingDomestic;
